(() => {
  const isHome = () =>
    document.body.classList.contains("t-index") ||
    document.body.classList.contains("t-home") ||
    !!document.querySelector("body.t-index");

  const getHeader = () =>
    document.querySelector("sticky-header") ||
    document.querySelector(".header-wrapper") ||
    document.querySelector("header");

  const TOP_THRESHOLD = 8;       // à partir de quel scroll on quitte l'état "top"
  const REVEAL_THRESHOLD = 80;   // à partir de quel scroll on commence le comportement venezia

  let lastY = window.scrollY;
  let ticking = false;

  const setTopState = (h) => {
    h.classList.remove("venezia-header--fixed", "venezia-header--hidden");
    h.classList.add("venezia-header--shown");
  };

  const setHiddenFixed = (h) => {
    h.classList.add("venezia-header--fixed", "venezia-header--hidden");
    h.classList.remove("venezia-header--shown");
  };

  const setShownFixed = (h) => {
    h.classList.add("venezia-header--fixed", "venezia-header--shown");
    h.classList.remove("venezia-header--hidden");
  };

  const onScroll = () => {
    const h = getHeader();
    if (!h) return;

    const y = window.scrollY;
    const goingUp = y < lastY;
    const nearTop = y <= TOP_THRESHOLD;

    if (nearTop) {
      // Transparent + non sticky
      setTopState(h);
    } else if (y < REVEAL_THRESHOLD) {
      // zone "tampon" : on peut choisir de le cacher vite ou le laisser comme top
      // Option Venezia: le cacher dès qu'on commence à descendre
      if (goingUp) setTopState(h);
      else setHiddenFixed(h);
    } else {
      // comportement principal
      if (goingUp) setShownFixed(h);
      else setHiddenFixed(h);
    }

    lastY = y;
  };

  const init = () => {
    if (!isHome()) return;
    const h = getHeader();
    if (!h) return;

    // état initial
    setTopState(h);

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            onScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
  };

  if (document.readyState === "complete" || document.readyState === "interactive") init();
  else document.addEventListener("DOMContentLoaded", init, { once: true });
})();
